import {
  ApiOutlined,
  BookOutlined,
  FileTextOutlined,
  MessageOutlined,
  RobotOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@context/auth-context';

const SECTIONS = [
  {
    key: '/dialogs',
    icon: <MessageOutlined />,
    title: 'Диалоги',
    description: 'Переписка с клиентами и ответы агентов в одном потоке.',
    adminOnly: false,
  },
  {
    key: '/channels',
    icon: <ApiOutlined />,
    title: 'Каналы',
    description: 'Подключения и статусы внешних каналов связи.',
    adminOnly: true,
  },
  {
    key: '/agents',
    icon: <RobotOutlined />,
    title: 'Агенты',
    description: 'Роли, инструкции и инструменты киберсотрудников.',
    adminOnly: true,
  },
  {
    key: '/spaces',
    icon: <BookOutlined />,
    title: 'Пространства',
    description: 'Базы знаний, по которым агенты ищут ответы.',
    adminOnly: true,
  },
  {
    key: '/articles',
    icon: <FileTextOutlined />,
    title: 'Статьи',
    description: 'Материалы и фрагменты для поиска по знаниям.',
    adminOnly: true,
  },
  {
    key: '/users',
    icon: <TeamOutlined />,
    title: 'Пользователи',
    description: 'Доступ команды и роли администраторов.',
    adminOnly: true,
  },
];

const Welcome = () => {
  const navigate = useNavigate();
  const { isAdmin, currentUser } = useAuth();
  const greetingName = currentUser?.name || currentUser?.email || 'команда';
  const cards = SECTIONS.filter((section) => isAdmin || !section.adminOnly);

  return (
    <div className="welcome-page">
      <div className="welcome-hero">
        <div className="welcome-kicker">Киберменеджер</div>
        <h1 className="welcome-title">Рабочее пространство агентов</h1>
        <p className="welcome-subtitle">
          Здравствуйте, {greetingName}. Здесь диалоги, знания и инструменты собраны
          в одну спокойную панель управления.
        </p>
      </div>
      <div className="welcome-grid">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            className="welcome-card"
            onClick={() => navigate(card.key)}
          >
            <span className="welcome-card-icon">{card.icon}</span>
            <span className="welcome-card-title">{card.title}</span>
            <span className="welcome-card-text">{card.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Welcome;
